// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import SelectNetworkForDisplayPaths from '../app/select-network-for-display-paths';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Network',
                        component: SelectNetworkForDisplayPaths,
                    },
                ],
            },
        ],
    },
};

function DashboardSelectNetworkForDisplayPaths() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="dashboardSelectNetworkForDisplayPaths"
            version="1"
        />
    );
}

export default DashboardSelectNetworkForDisplayPaths;
